import React from 'react';
import $ from "jquery";
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Button from '@material-ui/core/Button';
import Loading from '../../loading';
import Server from '../../../functions/server';
import { Doughnut } from 'react-chartjs-2';
import { Grid } from 'semantic-ui-react';
import LineReport from './LineReport';
import { LineChart, PieChart } from 'react-chartkick'
import 'chartkick/chart.js'

export default class DashBoardWithChart extends React.Component {

  state = {
    branchs: [], allCheckBox: true, dropdownValue: 7, salesDetails: [],
    fromDate: this.getDate(new Date(), 7), branchArray: [],
    toDate: this.getDate(new Date()),
  }

  componentDidMount() {
      this.getBranch();
  }

  getBranch() {
    let context = this;
    context.setState({ loading: false, message: 'Getting Branch Details!!!' });
    
    $.ajax({
      url: Server()+'executivebranch/getbranch.php',
      method: 'POST',  data: { 'userId': 13 },
      success: (data) => {
        let getBranch = [];
        try {
          data = JSON.parse(data);
          data.map((c) => {
            let branchColor = '#000000';
            context.props.thisfinacialYearSalesDetails.map((d) => {
              if (d.name == c.name) {
                branchColor = d.color;
              }
            })
            c.color = branchColor;
            c.checked = true;
            getBranch.push({ id: c.branch_id, name: c.name });
          })
          context.getSalesDetailData(getBranch);
          context.setState({ branchs: data, branchArray: getBranch, loading: false, allCheckBox: true })
        } catch (e) {
            context.setState({ loading: false });
        }
      },
      error: (e) => {
        context.setState({ loading: false, error: 'Try again!!!' });
      }
    });
  }

  getSalesDetailData(branch) {
    let context = this;
    let { fromDate, toDate } = this.state;
    branch = JSON.stringify(branch);
    $.ajax({
      type: 'POST', data: { branch, fromDate, toDate },
      url: Server() + 'ChartDashboard/GetSalesDetailDifferentView.php',
      success: function(data) {
        try {
          data = JSON.parse(data);
          context.setState({ salesDetails: data })
        } catch (error) {
        }
      },
      error: function(e) {
        alert('Try again!!')
        context.setState({ load: false });
      }
    });
  }

  allCheckBoxHandlers = (id) => event => {
    let branchs = this.state.branchs;
    branchs.map((c) => { if (c.id == id) { c.checked = event.target.checked; } })
    let lengthOfArray = branchs.length;
    let i = 0;
    branchs.map((c) => { if (c.checked) { i++; } })
    if (i == lengthOfArray) {
      this.setState({ branchs, allCheckBox: true })
    }
    else {
      this.setState({ branchs, allCheckBox: false })
    }
  }

  allCheckBoxHandler = (event) => {
    let branchs = this.state.branchs;
    if (event.target.checked) {
      branchs.map((c) => {
        c.checked = true;
      })
      this.setState({ allCheckBox: event.target.checked, branchs })
    }
    else {
      branchs.map((c) => {
        c.checked = false;
      })
      this.setState({ allCheckBox: event.target.checked, branchs })
    }
  }

  onChangeSelectBox = event => {
    if (event.target.value == 7 || event.target.value == 30) {
      let fromDate = this.getDate(new Date(), event.target.value);
      let toDate = this.getDate(new Date());
      this.setState({ fromDate, toDate, dropdownValue: event.target.value })
    }
    else {
      let fromDate = this.getDate(new Date(), event.target.value);
      let toDate = this.getDate(new Date());
      this.setState({ fromDate, toDate, dropdownValue: event.target.value })
    }
  }


  getDate(dates, interval) {
    if (interval > 0) {
        dates = new Date(dates.getTime() - (interval * 24 * 60 * 60 * 1000));
    }
    let month = dates.getMonth() + 1; let date = dates.getDate();
    month = (month > 10) ? month : "0" + month;
    date = (date > 10) ? date : "0" + date;
    let x;
    if (interval == 'year') {
      x = dates.getFullYear() + "-" + '04' + "-" + '01';
    }
    else {
      x = dates.getFullYear() + "-" + month + "-" + date;
    }
    return x;
}

convertIntoNumber(value) {
  try {
    value = Number(value);
  } catch (error) {
    value = 0;
  }
  return value;
}

  setData(salesDetails) {
    let array = [];
    let addDuplicateData = this.addDuplicateData(salesDetails);
    salesDetails.map((c) => {
      let values = c.values;
      let valueArray = {};
      addDuplicateData.map((a) => {
        let total = 0;
        values.map((c) => {
          if (a == c.date) {
            total = c.total;
          }
        })
        let date = a;
        valueArray[date] = total;
      })
      array.push({ name: c.name, data: valueArray })
    })
    return array;
  }

  addDuplicateData(salesDetails) {
    let array = [];
    salesDetails.map((c) => {
      let values = c.values;
      values.map((v) => {
        array.push( v.date )
      })
      
    })
    var uniqueNames = [];
    $.each(array, function(i, el){
      if($.inArray(el, uniqueNames) === -1) uniqueNames.push(el);
    });
    return uniqueNames;
  }

  render() {
    let { branchs, allCheckBox, dropdownValue, fromDate, toDate, salesDetails } = this.state;
    let data = this.setData(salesDetails);
    return (
      <div style={{margin: '2%'}}>
        <Loading load={this.state.load} message={this.state.message} />
        <div style={{display: 'flex'}}>
          <FormControl style={{width: '300px'}}>
            <Select value={dropdownValue} onChange={this.onChangeSelectBox} labelId="demo-simple-select-label" id="demo-simple-select" >
              <MenuItem value={7}>7</MenuItem>
              <MenuItem value={30}>30</MenuItem>
              <MenuItem value={'year'}>This Year</MenuItem>
            </Select>
            
          </FormControl>
          <Button onClick={this.getSalesDetailData.bind(this, this.state.branchArray)} style={{marginLeft: '2%'}} variant="contained" color="primary">
            Submit
          </Button>
        </div>
        
        <Grid style={{display: 'none'}}>
            <Grid.Column mobile={16} tablet={16} computer={3}>
                <FormControlLabel
                    control={
                    <Checkbox
                        checked={allCheckBox}
                        name="checkedB"
                        onChange={this.allCheckBoxHandler}
                        color="primary"
                    />
                    }
                    label={'ALL'}
                />
            </Grid.Column>
            { 
                branchs.map((c) => {
                    return (
                        <Grid.Column mobile={16} tablet={16} computer={3}>
                            <FormControlLabel
                                control={
                                <Checkbox
                                    checked={c.checked}
                                    name="checkedB"
                                    onChange={this.allCheckBoxHandlers(c.id)}
                                    color={c.color}
                                    style={{color: c.color}}
                                />
                                }
                                label={c.name}
                            />
                        </Grid.Column>
                    )
                })
            }
        </Grid>
        <center style={{marginTop: '2%'}}>
            <b>{fromDate+" to "+toDate}</b>
        </center>
        <LineChart data={data} />
      </div>
    );
  }

}

